import { render } from "./Index.vue?vue&type=template&id=53179394&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=53179394&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-53179394"

export default script